import { AiOutlineMonitor, AiOutlineUser } from "react-icons/ai";
import { MdBrowserNotSupported, MdInsertChartOutlined, MdMonitor, MdOutlineAdminPanelSettings } from "react-icons/md";

// Page Title: Comprehensive Proctoring Solution
export const proctoData = [
    {
        title: "Candidate Authentication",
        video: false,
        videoId: "",
        videoType: "",
        icon: <AiOutlineUser className='text-white fs-5' />
    },
    {
        title: "Real-time Candidate Monitoring",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdMonitor className='text-white fs-5' />
    },
    {
        title: "Advanced Admin Control Features",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdOutlineAdminPanelSettings className='text-white fs-5' />
    },
    {
        title: "Browsing Limitation",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdBrowserNotSupported className='text-white fs-5' />
    },
    {
        title: "Detailed Exam Report",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdInsertChartOutlined className='text-white fs-5' />
    }
]